function in_array(the_needle, the_haystack) {
    for(i=0;i<the_haystack.length;i++) {
    	if(the_haystack[i] == the_needle) {
    		return true;
    	}
    }
    return false;
}

function ShowHide(tag, id) {
	var showHide = false;
	obj = document.getElementsByTagName(tag);
	if(obj[id]) {
		if (obj[id].style.display == "none" || obj[id].style.display == "")  {
			if (tag == 'table') {
				type = "table";
			}
			else {
				type = "block";
			}
			obj[id].style.display = type;

			showHide = true;
		}
		else {
			obj[id].style.display = "none";
		}
	}
	return showHide;
}

function menuOpen(parent)
{
	var kaka = getCookie('open_menu_items');
	var kakaArr = kaka.split(/:/g);
	var menuAnchor = document.getElementById('a'+parent);
	if (ShowHide('ul', 'c' + parent)) { // Opening
		if(!in_array(parent, kakaArr)) {
			kaka += parent+':';
			setCookie('open_menu_items', kaka, 1, '/');
		}
		removeClassName(menuAnchor, 'closed');
		addClassName(menuAnchor, 'open');
	}
	else { // Closing
    	var regexp = new RegExp(parent+':', 'g');
		kaka = kaka.replace(regexp, '');
		setCookie('open_menu_items', kaka, 1, '/');
		removeClassName(menuAnchor, 'open');
		addClassName(menuAnchor, 'closed');
	}
	return false;
}

function setCookie(name, value, numOfDays, path, domain, secure )
{
	var today = new Date();
	var expire = new Date();

	if (numOfDays==null||numOfDays==0) numOfDays = 0;
	expires = numOfDays * 1000 * 60 * 60 * 24;
	var expire = new Date(today.getTime() + expires);

	document.cookie = name+'='+escape(value) +
		((expires) ? ';expires='+expire.toGMTString() : '' ) +
		((path) ? ';path=' + path : '' ) +
		((domain) ? ';domain=' + domain : '' ) +
		((secure) ? ';secure' : '' );
}

function getCookie(name)
{
	var dc = document.cookie;
	var prefix = name + "=";
	var begin = dc.indexOf("; " + prefix);
	if (begin == -1) {
		begin = dc.indexOf(prefix);
		if (begin != 0) return '';
	}
	else {
		begin += 2;
	}
	var end = document.cookie.indexOf(";", begin);
	if (end == -1) {
		end = dc.length;
	}
	return unescape(dc.substring(begin + prefix.length, end));
}

function trim(string) {
    return string.replace( /^\s+|\s+$/, "" );
}

function addClassName (elem, className) {
    removeClassName (elem, className);
    elem.className = trim(elem.className + " " + className);
}

function removeClassName (elem, className) {
    elem.className = trim(elem.className.replace(className, ""));
}

/**
 *jQuery scripts
 */
function closeMessage(closer) {
	closer.hide();
	$('#message-' + closer.attr('id')).fadeOut('slow');
}
function dagsPunktur(elm)
{
	var value = elm.value;
	if((value.length == 2) || (value.length == 5)) {
		value = value + '.';
		elm.value = value;
		return false;
	}
	else {
		return true;
	}
}